import { type ChangeEventHandler, type FC } from 'react';
import { TextInput, type TextInputProps } from '@mantine/core';
import { formatPhoneNumberInput, normalizePhoneNumberInput } from '../../lib/formatter';

export interface PhoneInputProps extends Omit<TextInputProps, 'defaultValue' | 'onChange' | 'type' | 'value'> {
    value?: string | null;
    onChange?: (value: string) => void;
}

export const PhoneInput: FC<PhoneInputProps> = ({
    autoComplete = 'tel',
    inputMode = 'tel',
    onChange,
    placeholder = '+7 999 123 45 67',
    value,
    ...props
}) => {
    const handleChange: ChangeEventHandler<HTMLInputElement> = ({ currentTarget: { value } }) => {
        onChange?.(normalizePhoneNumberInput(value));
    };

    return (
        <TextInput
            {...props}
            autoComplete={autoComplete}
            inputMode={inputMode}
            onChange={handleChange}
            placeholder={placeholder}
            type='tel'
            value={formatPhoneNumberInput(value ?? '')}
        />
    );
};
